import {Component,OnInit,ViewChild,ElementRef,OnDestroy} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomerDropdownComponent } from './customer-dropdown/customer-dropdown.component';
import { ChatService } from '../../services/chat.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Message as ChatServiceMessage } from 'src/app/shared/models/chat.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [CommonModule, FormsModule, CustomerDropdownComponent],
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit, OnDestroy {
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;

  messages: ChatServiceMessage[] = [];
  inputMessage = '';
  isLoading = false;
  hasStarted = false;

  // Scroll control
  private shouldScrollToBottom = true;
  private previousMessageCount = 0;

  // Subscriptions
  private messagesSubscription!: Subscription;
  private isLoadingSubscription!: Subscription;

  // Customer properties
  selectedCustomer: any;
  visibility: string = 'external';
  visibilityCustomer: boolean = false;
  userInfo: any = null;
  private readonly CUSTOMER_STORAGE_KEY = 'studioip_selected_customer';

  constructor(
    private chatService: ChatService,
    private sanitizer: DomSanitizer
  ) { }

  // ---------------- INIT ----------------
  // ngOnInit(): void {
  //   this.messagesSubscription = this.chatService.messages$.subscribe(
  //     messages => {
  //       const isNewMessage =
  //         messages.length > this.previousMessageCount;

  //       this.previousMessageCount = messages.length;
  //       this.messages = messages;
  //       this.hasStarted = messages.length > 1;

  //       if (isNewMessage && this.shouldScrollToBottom) {
  //         setTimeout(() => this.scrollToBottom(), 0);
  //       }
  //     }
  //   );

  //   this.isLoadingSubscription =
  //     this.chatService.isLoading$.subscribe(
  //       loading => (this.isLoading = loading)
  //     );

  //   this.checkUserVisibility();
  // }
  ngOnInit(): void {
  // Load saved customer selection first
  this.loadCustomerSelection();
  
  // Then check user visibility
  this.checkUserVisibility();
  
  // Rest of your existing code...
  this.messagesSubscription = this.chatService.messages$.subscribe(
    messages => {
      const isNewMessage = messages.length > this.previousMessageCount;
      this.previousMessageCount = messages.length;
      this.messages = messages;
      this.hasStarted = messages.length > 1;

      if (isNewMessage && this.shouldScrollToBottom) {
        setTimeout(() => this.scrollToBottom(), 0);
      }
    }
  );

  this.isLoadingSubscription = this.chatService.isLoading$.subscribe(
    loading => (this.isLoading = loading)
  );
}

  // ---------------- DESTROY ----------------
  ngOnDestroy(): void {
    if (this.messagesSubscription) {
      this.messagesSubscription.unsubscribe();
    }
    if (this.isLoadingSubscription) {
      this.isLoadingSubscription.unsubscribe();
    }
  }

  // ---------------- SCROLL ----------------
  private scrollToBottom(): void {
    try {
      const element = this.messagesContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    } catch (e) {
      console.error('Scroll error:', e);
    }
  }

  onMessagesScroll(): void {
    const element = this.messagesContainer.nativeElement;
    const atBottom =
      element.scrollHeight - element.scrollTop - element.clientHeight < 50;

    this.shouldScrollToBottom = atBottom;
  }

  // ---------------- CHAT ACTIONS ----------------
  async sendMessage(): Promise<void> {
    if (
      this.inputMessage.trim() &&
      !this.isLoading &&
      this.selectedCustomer
    ) {
      this.shouldScrollToBottom = true;
      await this.chatService.sendMessage(this.inputMessage);
      this.inputMessage = '';
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (
      event.key === 'Enter' &&
      !event.shiftKey &&
      this.selectedCustomer
    ) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  // resetChat(): void {
  //   if (
  //     confirm(
  //       'Are you sure you want to reset the chat? All conversation history will be cleared.'
  //     )
  //   ) {
  //     this.hasStarted = false;
  //     this.previousMessageCount = 0;
  //     this.chatService.clearChat();
  //     this.shouldScrollToBottom = true;
  //   }
  // }
  resetChat(): void {
  if (
    confirm(
      'Are you sure you want to reset the chat? All conversation history will be cleared.'
    )
  ) {
    this.hasStarted = false;
    this.previousMessageCount = 0;
    this.chatService.clearChat();
    this.shouldScrollToBottom = true;
    
    // Clear customer selection from storage
    localStorage.removeItem('studioip_selected_customer');
    
    // Reset dropdown
    this.selectedCustomer = null;
  }
}

  // ---------------- MESSAGE FORMAT ----------------
  formatMessage(content: string): SafeHtml {
    if (!content) return '';

    let html = content
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/\n/g, '<br>')
      .replace(/^\s*[-*]\s+(.*)/gm, '<li>$1</li>')
      .replace(/(<br>\s*){2,}/g, '</p><p>');

    if (!html.includes('<li>') && !html.startsWith('<h')) {
      html = `<p>${html}</p>`;
    }

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  // ---------------- AVATAR FALLBACK ----------------
  useFallbackAvatar(event: any, type: 'user' | 'bot'): void {
    const imgElement = event.target as HTMLImageElement;
    const parent = imgElement.parentElement;

    if (parent) {
      const fallbackDiv = document.createElement('div');
      fallbackDiv.className = `avatar-fallback ${type}-fallback`;
      fallbackDiv.textContent = type === 'user' ? 'U' : 'AI';
      parent.replaceChild(fallbackDiv, imgElement);
    }
  }

  // ---------------- CUSTOMER ----------------
  // onCustomerSelected(customer: any): void {
  //   if (customer) {
  //     this.selectedCustomer = customer;
  //     const customerId = customer.customers_id || customer.id;
  //     this.chatService.setCurrentCustomer(customerId);
  //   } else {
  //     this.selectedCustomer = null;
  //     this.chatService.setCurrentCustomer(null);
  //   }
  // }
  onCustomerSelected(customer: any): void {
  if (customer) {
    this.selectedCustomer = customer;
    const customerId = customer.customers_id || customer.id;
    
    // Save customer selection to localStorage
    this.saveCustomerSelection(customer);
    
    // Pass customer company to chat service
    this.chatService.setCurrentCustomer(customerId, customer.customers_company);
  } else {
    this.selectedCustomer = null;
    this.chatService.setCurrentCustomer(null);
    
    // Clear customer selection from storage
    localStorage.removeItem(this.CUSTOMER_STORAGE_KEY);
  }
}
private saveCustomerSelection(customer: any): void {
  try {
    const customerData = {
      id: customer.customers_id || customer.id,
      company: customer.customers_company,
      timestamp: Date.now()
    };
    localStorage.setItem(this.CUSTOMER_STORAGE_KEY, JSON.stringify(customerData));
  } catch (error) {
    console.error('Error saving customer selection:', error);
  }
}

// Add method to load customer selection
private loadCustomerSelection(): void {
  try {
    const savedCustomer = localStorage.getItem(this.CUSTOMER_STORAGE_KEY);
    if (savedCustomer) {
      const customerData = JSON.parse(savedCustomer);
      
      // Check if saved within last 24 hours
      const isExpired = Date.now() - customerData.timestamp > 24 * 60 * 60 * 1000;
      
      if (!isExpired && customerData.id) {
        // Create a temporary customer object to maintain dropdown selection
        this.selectedCustomer = {
          customers_id: customerData.id,
          customers_company: customerData.company
        };
        
        // Update chat service
        this.chatService.setCurrentCustomer(customerData.id, customerData.company);
      }
    }
  } catch (error) {
    console.error('Error loading customer selection:', error);
  }
}

  private checkUserVisibility(): void {
    const userInfoString = localStorage.getItem('userInfo');

    if (!userInfoString) return;

    try {
      this.userInfo = JSON.parse(userInfoString);
      this.visibility =
        this.userInfo['custom:visibility'] || 'local';
      this.visibilityCustomer =
        this.visibility === 'customer';

      if (this.visibilityCustomer && this.userInfo) {
        this.selectedCustomer = {
          customers_company:this.userInfo.company ||this.userInfo.name ||'Customer',
          customers_id:this.userInfo.id ||this.userInfo.external_id ||'CUSTOMER'
        };

        this.chatService.setCurrentCustomer(
          this.selectedCustomer.customers_id
        );
      }
    } catch (error) {
      console.error('Error parsing user info:', error);
    }
  }
}
